window.TEV_SCORING = {
  score_scale: {
    min: 1,
    max: 10
  },

  priorities: {
    lowest_ownership_cost: {
      weights: {
        value: 0.30,
        first_ev_friendliness: 0.10,
        charging_confidence: 0.10,
        city_fit: 0.05,
        motorway_fit: 0.05,
        family_fit: 0.05,
        range_confidence: 0.10,
        premium_feel: 0.00,
        long_term_confidence: 0.15,
        tech_appeal: 0.00,
        calculated_period_cost_score: 0.10
      }
    },
    longest_range: {
      weights: {
        value: 0.05,
        first_ev_friendliness: 0.05,
        charging_confidence: 0.15,
        city_fit: 0.00,
        motorway_fit: 0.20,
        family_fit: 0.05,
        range_confidence: 0.30,
        premium_feel: 0.05,
        long_term_confidence: 0.10,
        tech_appeal: 0.05
      }
    }
  }
};